define( function() {
	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/css/var/rmargin.js
// module id = 866
// module chunks = 0